import { DatePipe } from '@angular/common'
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatStepper } from '@angular/material/stepper'
// TODO:Spartacus - Many methods from 'UserService' were removed, for more details please look into 4.0 migration documentation.
import { Address, GlobalMessageType, RoutingService } from '@spartacus/core'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.
import { CustomFormValidators, ICON_TYPE, LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront'
// ModalService
import { Dialog } from '@angular/cdk/dialog'
import { MatDatepicker } from '@angular/material/datepicker'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators'
import {
  DispenserAgreementsSubmitPayload,
  DispenserCategories,
  DispenserTypes
} from '../../../../../models/dispensers.model'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'
import { DispenserType } from '../../../../../models/enum/dispenser.enum'
import { SharedValue } from '../../../../../models/enum/shared.enum'
import { ICustomOrgUnit } from '../../../../../models/interface/org-unit.interface'
import { ICustomProduct } from '../../../../../models/interface/product.interface'
import { ICustomUser } from '../../../../../models/interface/user.interface'
import { DispenserAgreementService } from '../../../../../services/agreement/dispenser/dispenser-agreement.service'
import { AppConfigurationService } from '../../../../../services/app-configuration.service'
import { BusinessUnitService } from '../../../../../services/business-unit.service'
import { CustomGlobalMessageService } from '../../../../../services/shared/custom-global-message/custom-global-message.service'
import { CustomTableColumnType } from '../../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'
import { DispenserEndCustomerComponent } from '../dispenser-end-customer/dispenser-end-customer.component'
import { NewDispenserAgreementModalComponent } from '../new-dispenser-agreement-modal/new-dispenser-agreement-modal.component'

@Component({
  selector: 'app-new-dispenser-agreement',
  templateUrl: './new-dispenser-agreement.component.html',
  styleUrls: ['./new-dispenser-agreement.component.scss'],
  standalone: false
})
export class NewDispenserAgreementComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()

  agreementTypeFormGroup: FormGroup
  endCustomerFormGroup: FormGroup
  requesterFormGroup: FormGroup
  termInformationFormGroup: FormGroup
  reviewFormGroup: FormGroup
  assetSelectionFormGroup: FormGroup
  selectedProduct: string
  activeCategory: string
  @ViewChild('stepper') stepper: MatStepper
  selectedAgreementProducts: Map<string, any> = new Map<string, any>()

  modalRef: any

  unit: any

  public dispenserCategories: DispenserCategories = new DispenserCategories()
  public dispenserTypes: DispenserTypes = new DispenserTypes()
  public showInitialLoader: boolean = true
  public DispenserTypeEnum = DispenserType
  public iconTypes = ICON_TYPE
  public serviceProducts: Map<string, ICustomProduct[]> = new Map<string, ICustomProduct[]>()
  public categoryProducts: Map<string, ICustomProduct[]> = new Map<string, ICustomProduct[]>()
  public allCategoryProducts: Map<string, ICustomProduct[]> = new Map<string, ICustomProduct[]>()
  public user: ICustomUser
  public errorMessage: string
  public newCustomer: boolean = false
  public existingAddress: boolean = false
  public businessAddresses: Map<string, Address[]> = new Map<string, Address[]>()
  public agreementTypeSelected: boolean = false
  public requestSubmitted: boolean = false
  public selectedServiceProduct: ICustomProduct
  public dispenserSubmit: string
  public showStepperLoader: boolean = false
  private currentDate: Date
  public agreementReferenceNumber: string

  public headers: ICustomTableHeader[] = [
    { title: 'dispenserAgreement.item', cssStyle: 'min-width:200px' },
    { title: 'dispenserAgreement.itemNumber' },
    { title: 'dispenserAgreement.colour' },
    { title: 'dispenserAgreement.system' },
    { title: 'dispenserAgreement.systemType' },
    { title: 'dispenserAgreement.quantity', type: CustomTableColumnType.INPUT }
  ]

  public columns: ICustomTableColumn[] = [
    { key: 'name', cssStyle: 'min-width:200px' },
    { key: 'code' },
    { key: 'colour' },
    { key: 'refillID' },
    { key: 'systemType' },
    {
      key: 'quantity',
      type: CustomTableColumnType.INPUT,
      input: { type: 'text', value: 'quantity', translate: true, bindInput: true }
    }
  ]

  constructor(
    private _formBuilder: FormBuilder,
    public dispenserAgreementService: DispenserAgreementService,
    private changeDetectorRef: ChangeDetectorRef,
    public routingService: RoutingService,
    private modalService: LaunchDialogService,
    public userService: UserAccountFacade,
    public businessUnitService: BusinessUnitService,
    public globalMessageService: CustomGlobalMessageService,
    public datepipe: DatePipe,
    public dialog: Dialog
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  public userId = JSON.parse(sessionStorage.getItem('userDetails'))

  ngOnInit(): void {
    this.formGroupsValidation()
    this.getDispenserTypes()

    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.

    console.log('loggedin........>', this.user)

    this.userService.get().subscribe((res) => {
      this.user = res
      this.setRequesterFormValues()
    })

    this.dispenserSubmit = `${AppConfigurationService.settings.dispenser.dispenserSubmit}`
  }

  public formGroupsValidation() {
    this.agreementTypeFormGroup = this._formBuilder.group({
      agreementType: ['', Validators.required]
    })
    this.endCustomerFormGroup = this._formBuilder.group({
      businessName: ['', Validators.required],
      addressLine1: ['', Validators.required],
      abn: [''],
      email: ['', Validators.required],
      addressLine2: [''],
      acAccountNumber: [''],
      phoneNumber: ['', Validators.required],
      postcode: ['', Validators.required],
      installer: ['', Validators.required],
      state: [''],
      installReason: [''],
      contactName: ['', Validators.required]
    })
    this.requesterFormGroup = this._formBuilder.group({
      requesterName: [''],
      requesterAddressLine1: [''],
      distributionPartner: [''],
      requesterAddressLine2: [''],
      requesterAbn: [''],
      requesterPostcode: [''],
      requesterEmail: [''],
      requesterState: [''],
      requesterPhoneNumber: [''],
      acRepresentativeEmail: ['', [Validators.required, CustomFormValidators.emailValidator]]
    })

    this.termInformationFormGroup = this._formBuilder.group({
      accept: [false, Validators.required],
      comments: ['']
    })
    this.reviewFormGroup = this._formBuilder.group({})
    this.assetSelectionFormGroup = this._formBuilder.group({
      selectedAgreementProduct: ['', Validators.required],
      searchText: ['']
    })

    this.getSearchText()
      .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        this.searchAssets(value)
      })
  }

  public get disableTermInformation(): boolean {
    return !this.termInformationFormGroup?.value?.accept
  }

  public getServiceProducts(): void {
    for (const serviceType of this.dispenserTypes.servicesTypes) {
      this.dispenserAgreementService.getServiceProducts(serviceType).subscribe((res) => {
        if (res && res.length > 0) {
          this.serviceProducts.set(serviceType, res)
        }
      })
    }
  }

  public onTypeInfoClick(type: string): void {
    // const modalRef = this.modalService.open(NewDispenserAgreementModalComponent, {centered: true});
    // modalRef.componentInstance.dispenserType = type;

    this.modalRef = this.modalService.openDialog(
      LAUNCH_CALLER.ADDED_TO_CART,
      undefined,
      undefined,
      NewDispenserAgreementModalComponent
    )
  }

  public selectServiceType(type: string): void {
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    const serviceProducts = this.serviceProducts.get(type)
    this.selectedServiceProduct = serviceProducts && serviceProducts[0] ? serviceProducts[0] : null

    if (this.selectedServiceProduct) {
      this.selectedProduct = serviceProducts[0].name
      this.agreementTypeSelected = true
    } else {
      this.globalMessageService.add(SharedValue.serviceProductsNotFound, GlobalMessageType.MSG_TYPE_WARNING)
      this.agreementTypeSelected = false
    }
  }

  public selectServiceProduct(productCode: string): void {
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    const serviceProducts = this.serviceProducts.get(this.agreementTypeFormGroup.value.agreementType)

    if (serviceProducts?.length) {
      for (const product of serviceProducts) {
        if (product.code == productCode) {
          this.selectedServiceProduct = product
          this.selectedProduct = product.name
        }
      }
    }
  }

  public moveToStep(index: number) {
    this.stepper.selectedIndex = index
  }

  public getDispenserCategories(folType: string) {
    const type = folType === 'TORK_LIBRA_DISPENSER' ? 'tork' : 'libra'

    return this.dispenserAgreementService.getDispenserCategories(type)
  }

  public getDispenserTypes() {
    this.showStepperLoader = true
    this.dispenserAgreementService.getDispenserTypes().subscribe((res) => {
      this.showStepperLoader = false
      this.dispenserTypes = res
      this.changeDetectorRef.detectChanges()
    })
  }

  public getCategoryProducts(folType: string): void {
    this.dispenserCategories = null
    this.agreementTypeSelected = false
    this.categoryProducts.clear()
    this.allCategoryProducts.clear()

    this.getDispenserCategories(folType)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.dispenserCategories = res
          this.agreementTypeSelected = true

          if (this.dispenserCategories?.values.length > 0) {
            for (const category of this.dispenserCategories?.values) {
              if (!this.categoryProducts.has(category.name)) {
                const payload = {
                  queryString: category.query.query.value
                }
                this.dispenserAgreementService.getCategoryProducts(payload).subscribe((res) => {
                  this.categoryProducts.set(category.name, res)
                  this.allCategoryProducts.set(category.name, res)
                  this.changeDetectorRef.detectChanges()
                })
              }
            }
          }
        },
        error: () =>
          this.globalMessageService.add({ key: 'shared.error.noDispenserCategory' }, GlobalMessageType.MSG_TYPE_ERROR)
      })
  }

  public get canMoveToEndCustomer(): boolean {
    return !(this.agreementTypeSelected && !!this.dispenserCategories?.values)
  }

  public setProductQuantity(product: any, category: string) {
    this.activeCategory = category
    if (product.quantity > 0) {
      this.selectedAgreementProducts.set(product.code, product)
      this.updateProductQuantity(product.quantity, product.code)
    } else {
      this.selectedAgreementProducts.delete(product.code)
      this.updateProductQuantity(0, product.code)
    }
  }

  updateProductQuantity(quantity: number, code: string) {
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    const products = this.categoryProducts.get(this.activeCategory)
    if (products?.length) {
      for (const categoryProduct of products) {
        if (categoryProduct.code == code) {
          categoryProduct.quantity = quantity
        }
      }
    }
  }

  public doStepAssetSelection(): void {
    if (this.agreementTypeFormGroup.value.agreementType) {
      this.stepper.selectedIndex = 3
    } else if (this.stepper.selectedIndex == 4) {
      this.stepper.selectedIndex = 0
    }
  }

  selectedRow = {}

  public getBusinessUnit(buid: string): void {
    const dialogRef = this.dialog.open(DispenserEndCustomerComponent, {})

    dialogRef.closed.subscribe((result) => {
      this.resetEndCustomerChecks()

      this.selectedRow = {
        result,
        town: result['shippingAddress']['town'],
        postalCode: result['shippingAddress']['postalCode'],
        line1: result['shippingAddress']['line1'],
        line2: result['shippingAddress']['line2'],
        phone: result['shippingAddress']['phone'],
        email: result['shippingAddress']['email'],
        uid: result['uid'],
        name: result['name']
      }

      this.selectAddressUpdated(this.selectedRow)
    })

    //  const modalRef = this.modalService.open(DispenserEndCustomerComponent, {centered: true, size: 'xl'});

    //  this.modalRef.componentInstance.businessId = buid;
    //  this.modalRef.result
    //          .then(
    //                  (businessUnit) => {
    //                    this.resetEndCustomerChecks();
    //                    this.selectAddress(businessUnit);
    //                  },
    //                  (err) => console.log(err)
    //          );
  }

  public newCustomerCreation(): void {
    this.resetEndCustomerChecks()
    this.newCustomer = true
    this.errorMessage = ''
  }

  public selectAddress(unit: ICustomOrgUnit): void {
    this.existingAddress = true
    this.endCustomerFormGroup.patchValue({
      abn: unit?.businessNumber,
      businessName: unit.name,
      contactName: '',
      addressLine1: unit?.shippingAddress?.line1,
      addressLine2: unit?.shippingAddress?.line2,
      email: unit?.shippingAddress?.email,
      acAccountNumber: unit.uid,
      phoneNumber: unit?.shippingAddress?.phone,
      postcode: unit?.shippingAddress?.postalCode,
      state: unit?.shippingAddress?.town
    })
    this.changeDetectorRef.detectChanges()
  }

  public selectAddressUpdated(unit: any): void {
    this.existingAddress = true
    this.endCustomerFormGroup.patchValue({
      abn: unit?.businessNumber,
      businessName: unit.name,
      contactName: '',
      addressLine1: unit.line1,
      addressLine2: unit.line2,
      email: unit.email,
      acAccountNumber: unit.uid,
      phoneNumber: unit.phone,
      postcode: unit.postalCode,
      state: unit.town
    })
    this.changeDetectorRef.detectChanges()
  }

  public resetEndCustomerChecks(): void {
    this.newCustomer = false
    this.existingAddress = false
    this.endCustomerFormGroup.reset()
  }

  setRequesterFormValues() {
    // this.requesterFormGroup.controls.requesterName.setValue(this.user?.name);
    this.requesterFormGroup.controls.requesterName.setValue(this.userId?.name)
    this.requesterFormGroup.controls.requesterAddressLine1.setValue(this.userId.defaultAddress?.line1)
    this.requesterFormGroup.controls.distributionPartner.setValue(this.userId.orgUnit?.name)
    this.requesterFormGroup.controls.requesterAddressLine2.setValue(this.userId.defaultAddress?.line2)
    this.requesterFormGroup.controls.requesterAbn.setValue(this.userId.orgUnit?.abn)
    this.requesterFormGroup.controls.requesterPostcode.setValue(this.userId.defaultAddress?.postalCode)
    this.requesterFormGroup.controls.requesterEmail.setValue(this.userId?.uid)
    this.requesterFormGroup.controls.requesterState.setValue(this.userId.defaultAddress?.town)
    this.requesterFormGroup.controls.requesterPhoneNumber.setValue(this.userId.defaultAddress?.phone)
  }

  get disableEndCustomerForm(): boolean {
    if (this.existingAddress) {
      // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
      // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
      if (this.endCustomerFormGroup.get('installer').valid && this.endCustomerFormGroup.get('installReason').valid) {
        return false
      }
    } else if (this.endCustomerFormGroup.valid) {
      return false
    }
    return true
  }

  submitDispenserAgreementRequest() {
    this.showStepperLoader = true
    const products = []
    const agreementType = this.agreementTypeFormGroup.controls.agreementType.value

    if (agreementType == 'TORK_LIBRA_DISPENSER' || agreementType == 'LIBRA_PERIOD_POSITIVITY_PROGRAM') {
      this.selectedAgreementProducts.forEach((value: ICustomProduct, key: string) => {
        products.push({
          productCode: value.code,
          quantity: Number(value.quantity)
        })
      })
    } else {
      products.push({
        productCode: this.selectedServiceProduct.code
      })
    }

    const dispenserPayload: DispenserAgreementsSubmitPayload = {
      agreementTypes: {
        agreementType: agreementType,
        products: products
      },
      endCustomerInformation: {
        abn: this.endCustomerFormGroup.value.abn,
        addressLine1: this.endCustomerFormGroup.value.addressLine1,
        addressLine2: this.endCustomerFormGroup.value.addressLine2,
        businessName: this.endCustomerFormGroup.value.businessName,
        postalCode: this.endCustomerFormGroup.value.postcode,
        phoneNumber: this.endCustomerFormGroup.value.phoneNumber,
        state: this.endCustomerFormGroup.value.state,
        email: this.endCustomerFormGroup.value.email,
        installer: this.endCustomerFormGroup.value.installer,
        installReason: this.endCustomerFormGroup.value.installReason,
        contactName: this.endCustomerFormGroup.value.contactName
      },
      requesterInformation: {
        email: this.requesterFormGroup.value.requesterEmail,
        asaleoCareRepresentative: this.requesterFormGroup.value.acRepresentativeEmail,
        distributionCompany: this.user.orgUnit?.uid
      },
      termInformation: this.termInformationFormGroup.value
    }
    if (!this.newCustomer) {
      dispenserPayload.endCustomerInformation.businessName = this.endCustomerFormGroup.value.acAccountNumber
    }
    this.dispenserAgreementService.submitDispenserAgreement(dispenserPayload).subscribe(
      (res) => {
        this.agreementReferenceNumber = res
        this.showStepperLoader = false
        this.requestSubmitted = true
        this.changeDetectorRef.detectChanges()
      },
      (err) => {
        this.showStepperLoader = false
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
      }
    )
  }

  backToHistory(): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go({
      cxRoute: CustomRoutes.DISPENSER_AGREEMENT_HISTORY
    })
  }

  public getSearchText(): FormControl {
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    return this.assetSelectionFormGroup.get('searchText') as FormControl
  }

  searchAssets(searchText: string): void {
    const categorySearchProducts: Map<string, ICustomProduct[]> = new Map<string, ICustomProduct[]>()
    this.errorMessage = ''

    searchText = searchText?.trim().toLowerCase()
    if (searchText) {
      this.allCategoryProducts.forEach((products: ICustomProduct[], category: string) => {
        const searchedProducts = []
        for (const product of products) {
          if (product.name?.toLowerCase().includes(searchText) || product.code?.toLowerCase().includes(searchText)) {
            searchedProducts.push(product)
          }
        }
        if (searchedProducts.length > 0) {
          categorySearchProducts.set(category, searchedProducts)
        }
      })
      if (categorySearchProducts.size > 0) {
        this.categoryProducts = categorySearchProducts
      } else {
        this.categoryProducts = new Map<string, ICustomProduct[]>()
        this.errorMessage = SharedValue.errorProuctNotFound
      }
    } else {
      this.categoryProducts = this.allCategoryProducts
    }

    if (this.categoryProducts?.size) {
      for (const products of this.categoryProducts.values()) {
        if (products?.length) {
          for (const itemProduct of products) {
            if (this.selectedAgreementProducts.has(itemProduct.code)) {
              // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
              const { quantity } = this.selectedAgreementProducts.get(itemProduct.code)
              this.updateProductQuantity(quantity, itemProduct.code)
            }
          }
        }
      }
    }
    this.changeDetectorRef.detectChanges()
  }

  public get disableAssetSelection(): boolean {
    return (
      !this.assetSelectionFormGroup ||
      this.agreementTypeFormGroup.value.agreementType == 'SMART_CARE' ||
      !this.categoryProducts.size ||
      !this.selectedAgreementProducts.size
    )
  }

  public validateBusinessUnit(searchText: string): string {
    searchText = searchText.trim()
    if (!isNaN(Number(searchText))) {
      if (searchText.length < 10) {
        const zeroCount = 10 - searchText.length
        let leadingZero = ''
        for (let i = 0; i < zeroCount; ++i) {
          leadingZero += '0'
        }
        searchText = leadingZero + searchText
      }
    }
    return searchText
  }

  public openDatePicker(datepicker: MatDatepicker<any>): void {
    this.currentDate = new Date()
    this.currentDate.setHours(0, 0, 0, 0)

    datepicker.open()
  }

  disablePreviousDates = (datepickerDate: Date): boolean => {
    const date = datepickerDate
    if (date) {
      if (this.currentDate > date) {
        return false
      }
    }
    return true
  }

  public get getDispenserValue(): string {
    const { agreementType } = this.agreementTypeFormGroup.value
    switch (agreementType) {
      case 'TORK_LIBRA_DISPENSER':
        return 'Essity Australasia'

      case 'LIBRA_PERIOD_POSITIVITY_PROGRAM':
        return 'Libra Refills only'
    }
  }
}
